import React from 'react';
import { Box, Grid, Modal, Typography } from '@mui/material';
import RoundButton from '../components/roundButton';
import MemberComponent from './memberComponent';

const EditModalManifold = props => {
  const {
    open,
    handleClose,
    handleOnChange,
    data,
    handleCancel,
    lang,
    startData,
    sessionDataItems,
    stepName
  } = props;

  return (
    <Modal
      className="custom-modal-bg overflow-auto"
      open={open}
      onClose={handleClose}
      hideBackdrop
      disableEscapeKeyDown
    >
      <Box className="modal-common edit-modal">
        <Grid container>
          <Grid item xs={12} className="align-center">
            <Typography
              sx={{
                fontSize: '1.5rem !important',
                borderBottom: '1px solid #979797',
                padding: '1rem 0 !important',
                fontWeight: '500 !important',
                lineHeight: '1.2 !important'
              }}
            >
              Edit Work Section
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {data.map(member => {
              return (
                <div key={member.name}>
                  <MemberComponent
                    member={member}
                    showGroupHeader={true}
                    startData={startData}
                    handleOnChange={handleOnChange}
                    sessionDataItems={sessionDataItems}
                    stepName={stepName}
                    lang={lang}
                    imageUrls={startData?.imageControlURLs}
                  />
                </div>
              );
            })}
          </Grid>
          <Grid item xs={5.5}>
            <RoundButton name={lang?.CANCEL} onClick={handleCancel} />
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={5.5}>
            <RoundButton name={lang?.SAVE} onClick={handleClose} />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
export default EditModalManifold;
